import { Stack, styled } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme: { breakpoints } }) => ({
  height: '100%',
  justifyContent: 'space-between',
  [breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const StyledCenterWrapper = styled(Stack)(({ theme: { spacing } }) => ({
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  overflow: 'hidden',
  padding: spacing(0, 2),
}));

export const StyledMobileFooter = styled(Stack)(({ theme: { spacing, palette } }) => ({
  width: '100vw',
  padding: spacing(1.5, 2),
  borderTop: `1px solid ${palette.cvi.neutrals[30]}`,
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: palette.cvi.neutrals[10],
}));
